exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".homeTitle{\n\tfont-family: 'Marvel','sans-serif';\n\tfont-size:30px;\n\tline-height:1.3em;\n\tcolor: #444;\n}\n.newsTblHead{\n\ttext-align:center;\n\tfont-size:17px;\n\tcolor:#888;\n}\n.newsTblBody{\n\tpadding-top:25px;\n\tpadding-bottom:25px;\n}\n.newsTblBodyCont{\n\tfont-size:15px;\n\tfont-weight:bold;\n}\n.newsImage{\n\tmargin-bottom:10px;\n\tborder-radius:8px;\n}\n.cetTop{\n\tdisplay: block;\n\tmargin: 0 auto;\n\tborder: 10px solid #eee;\n}\t\n.cetName{\n\ttext-align: center;\n\tfont-weight: bold;\n\tpadding-bottom: 10px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/news/news.component.css
// module id = ../../../../../src/app/news/news.component.css
// module chunks = main